import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment.prod';

@Injectable()
export class ReporteService extends BaseAPIClass {
  baseUrl = '';
  public isLoading = false;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = this.baseUrl + '/reporte';
  }

  existencia(object: any) {
    return this.httpClient.post(this.baseUrl + '/stock', object);
  }
  monetizado(object: any) {
    return this.httpClient.post(this.baseUrl + '/monetizado', object);
  }

  ingresosAlmacen(object: any) {
    return this.httpClient.post(this.baseUrl + '/almacen', object);
  }
  ventasVendedor(object: any) {
    return this.httpClient.post(this.baseUrl + '/vendedor', object);
  }

  precioProductos(object: any) {
    return this.httpClient.post(this.baseUrl + '/productos', object);
  }
  ventaProductos(object: any) {
    return this.httpClient.post(this.baseUrl + '/ventaProductos', object);
  }
  productosPedidos(object: any) {
    return this.httpClient.post(this.baseUrl + '/pedidos', object);
  }

  reporteDeudores(object: any) {
    return this.httpClient.post(this.baseUrl + '/deudores', object);
  }

  
  segProducto(id: number) {
    return this.httpClient.get(this.baseUrl + '/producto/' + id);
  }

  reporteCobranzas(object: any) {
    return this.httpClient.post(this.baseUrl + '/cobranza', object);
  }

  /* getExistencia(obje){

  }*/
}
